import { TNsiBaseDto } from '@/common/types/nsi/common';
import { TApiResponse } from '@/common/types/response';

import { TIndicatorMonitoringState, TIndicatorPage } from './types';

export function setMonitoringPage(state: TIndicatorMonitoringState, res: { data: TIndicatorPage }) {
  state.monitoringPage = res.data;
}

export function setUpdateStatuses(state: TIndicatorMonitoringState, res: TApiResponse<TNsiBaseDto[]>) {
  state.updateStatuses = res.data ?? [];
}

export function setSources(state: TIndicatorMonitoringState, res: TApiResponse<TNsiBaseDto[]>) {
  state.sources = res.data ?? [];
}

export function setLoadError(state: TIndicatorMonitoringState, value: boolean) {
  state.loadError = value;
}
